import React, { useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import MedicationIcon from '@mui/icons-material/Medication';
import { medicationThumbnailUrl } from '../utils/medicationImage';

// A new URL mounts a new image state. A late event from an old photo cannot restore it.
export default function MedImage({ src, size = 40, loading = false }) {
    return <ImageForSource key={src || 'empty'} src={src} size={size} loading={loading} />;
}

function ImageForSource({ src, size, loading }) {
    const [fallback, setFallback] = useState(false);
    const [status, setStatus] = useState('loading');
    const displayedSrc = fallback ? src : medicationThumbnailUrl(src);
    const placeholder = !src || status === 'error';
    return (
        <Box sx={{ width: size, height: size, position: 'relative', borderRadius: 2, bgcolor: '#f5f5f5', overflow: 'hidden', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {src && !placeholder && !loading && (
                <Box component="img" key={displayedSrc} src={displayedSrc} alt="" loading="lazy" decoding="async"
                    onLoad={() => setStatus('loaded')}
                    onError={() => {
                        if (displayedSrc !== src) { setFallback(true); setStatus('loading'); }
                        else setStatus('error');
                    }}
                    sx={{ width: '100%', height: '100%', objectFit: 'cover', visibility: status === 'loaded' ? 'visible' : 'hidden' }} />
            )}
            {!loading && placeholder ? (
                <MedicationIcon sx={{ fontSize: size * 0.55, color: '#8a7000' }} />
            ) : (loading || status === 'loading') && (
                <CircularProgress size={Math.max(16, size * 0.45)} thickness={4} sx={{ position: 'absolute', color: '#8a7000' }} />
            )}
        </Box>
    );
}
